/**
 * Desktop mega-menu flyout.
 *
 * The flyout (each brand's child <ul>) stays where the theme renders it — a
 * child of its brand column. We do NOT move it in the DOM, so the theme's
 * hydration / DOM-morph can't undo anything.
 *
 * Open/close is JS with a short hover-intent so the pointer can cross the
 * scrollbar gap between the brand and the flush panel without it closing, and
 * moving to another brand closes the previous panel immediately (no lingering).
 * The flyout's containing block is .menu-list__submenu-inner (above the
 * scrolling list), so the list's scroll never clips it; JS only sets top/left.
 */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 990px)');
  var CLOSE_DELAY = 100; // ms — just enough to cross the scrollbar gap
  var BOTTOM_GAP_REM = 2; // min space to keep below the flyout / above (screen edges)
  var openCol = null;
  var closeTimer = null;

  // The child list lives at: li.mega-menu__column > div > ul
  function childList(column) {
    var wrap = column.firstElementChild;
    return wrap ? wrap.querySelector(':scope > ul') : null;
  }

  function place(column) {
    var ul = childList(column);
    if (!ul) return;
    var inner = column.closest('.menu-list__submenu-inner');
    if (!inner) return;
    var c = column.getBoundingClientRect();
    var i = inner.getBoundingClientRect();

    // Flush to the box's outer right edge.
    ul.style.left = i.right - i.left - inner.clientLeft + 'px';

    var rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    var gap = BOTTOM_GAP_REM * rem;
    var vh = window.innerHeight;

    // Full natural content height — scrollHeight already reports the whole
    // content even when max-height clips it, so no reset/reflow is needed.
    // Add the top/bottom border (scrollHeight excludes borders) + 1px so short
    // lists fit exactly and don't show a stray scrollbar.
    var cs = getComputedStyle(ul);
    var borderY = (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
    var content = ul.scrollHeight + borderY + 1;

    // Vertical band the flyout may occupy: from the top of the menu box down to
    // `gap` above the screen bottom.
    var topMin = Math.max(gap, i.top);
    var bottomMax = vh - gap;
    var bandH = bottomMax - topMin;

    // Prefer aligning the top to the hovered brand; if the items don't fit below
    // it, shift the flyout up (anchoring its bottom near the screen bottom) so it
    // shows as many as possible, then scroll for the rest.
    var height = Math.min(content, bandH);
    var top = c.top;
    if (top + height > bottomMax) top = bottomMax - height;
    if (top < topMin) top = topMin;

    ul.style.top = top - i.top - inner.clientTop + 'px';
    ul.style.maxHeight = height + 'px';

    // Force a persistent (non-overlay) scrollbar only when it actually scrolls,
    // so it's always visible on overlay-scrollbar platforms (ChromeOS/Mac) and
    // short lists show no scrollbar. 'scroll' forces the bar; 'hidden' hides it.
    ul.style.overflowY = content > height + 1 ? 'scroll' : 'hidden';
  }

  function open(column) {
    clearTimeout(closeTimer);
    if (openCol === column) return;
    if (openCol) openCol.classList.remove('flyout-open'); // close previous now
    openCol = column;
    column.classList.add('flyout-open');
    // Reset the panel's scroll to the top before it shows (in case it was left
    // scrolled down from a previous open).
    var ul = childList(column);
    if (ul) ul.scrollTop = 0;
    place(column);
    // Reposition once layout settles (submenu open animation on first hover).
    requestAnimationFrame(function () {
      if (openCol === column) place(column);
    });
  }

  function close() {
    if (openCol) openCol.classList.remove('flyout-open');
    openCol = null;
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, CLOSE_DELAY);
  }

  // Menu links are real links and should navigate — except "#" placeholders
  // (used for grouping-only parents), which would scroll the page to the top.
  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var a = e.target.closest('.menu-list a[href="#"], .menu-list__submenu a[href="#"]');
    if (a) e.preventDefault();
  });

  // Drawer menu: parent titles with a real link render as an <a> inside the
  // <summary> (see header-drawer.liquid) — clicking the link navigates,
  // clicking the rest of the row (incl. the caret) toggles the submenu. Stop
  // link clicks from also triggering the theme's slide-in submenu handler.
  document.addEventListener(
    'click',
    function (e) {
      if (!(e.target instanceof Element)) return;
      if (e.target.closest('summary .menu-drawer__parent-link')) e.stopPropagation();
    },
    true
  );

  document.addEventListener('pointerover', function (e) {
    if (!mq.matches) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var column = t.closest('.mega-menu__column');
    if (column && childList(column)) open(column);
  });

  document.addEventListener('pointerout', function (e) {
    if (!openCol) return;
    var rt = e.relatedTarget;
    // Moving to somewhere still inside the open column (incl. its flyout,
    // which is a descendant) keeps it open.
    if (rt && openCol.contains(rt)) return;
    scheduleClose();
  });

  // Keep the open panel aligned while the BRAND LIST scrolls (not when the
  // flyout scrolls its own content — that would fight the user's scroll).
  document.addEventListener(
    'scroll',
    function (e) {
      if (!openCol) return;
      var t = e.target;
      if (t && t.classList && t.classList.contains('mega-menu__list')) {
        place(openCol);
      }
    },
    true
  );
  window.addEventListener('resize', function () {
    if (openCol) place(openCol);
  });

  if (mq.addEventListener) {
    mq.addEventListener('change', function () {
      if (!mq.matches) close();
    });
  }
})();
